<template>
  <v-app>
    <div class="wrapper fill-height">
      <optionsNav v-model="drawerOption"></optionsNav>
      <v-app-bar color="primary" dark fixed app clipped-right>
        <v-toolbar-title>DomaGolf - Xperience</v-toolbar-title>
        <v-spacer/>
        <!--global-search / -->
        <v-btn to="/simulator/pos" text>POS</v-btn>
        <v-btn to="/simulator/dashboard" text>Agenda</v-btn>
        <v-btn to="/simulator/clients" text>Client</v-btn>
        <v-btn to="/simulator/planning" text>Planning</v-btn>
        <v-btn to="/simulator/simulators" text>Simulators</v-btn>
        <v-btn to="/simulator/options" text>Options</v-btn>
        <v-spacer/>
        <v-btn text to="/simulator/pos" v-if="order && $route.path != '/simulator/pos'"><v-icon small left>mdi-cart</v-icon> Total : {{total.toFixed(2)}} {{currency}}</v-btn>
        <v-btn text @click.stop="$router.push('/')">Return to Middleware</v-btn>
        <v-btn icon @click="logout">
          <v-icon>mdi-eject</v-icon>
        </v-btn>
      </v-app-bar>
      <main-nav v-model="drawerMain"></main-nav>
      <v-main class="fill-height">
        <v-container fluid class="d-flex">
          <v-row class="flex-grow-1">
            <v-col class="d-flex">
              <router-view class="flex-grow-1"></router-view>
              <v-snackbar v-model="snackDisplay" :timeout="2000" :color="snackColor" top>
                {{ snackText }}
              </v-snackbar>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import mainNav from "./mainNav.vue";
import optionsNav from "./optionsNav.vue";
import { mapGetters } from 'vuex';
export default {
  components: {
    mainNav,
    optionsNav,
  },
  data: () => ({
    drawerMain: false,
    drawerOption: false,
    right: false,
    left: false,
    snackDisplay: false
  }),
  computed: {
    ...mapGetters("pos",["total", "order", "currency"]),
    snackText: function() {
      return this.$store.getters["app/snackText"];
    },
    snackColor: function() {
      return this.$store.getters["app/snackColor"];
    }
  },
  watch: {
    snackText(newVal) {
      if (newVal) this.snackDisplay = true;
    },
    snackDisplay(newVal) {
      if (newVal == false) {
        this.closeSnack();
      }
    }
  },
  props: {
    source: String
  },
  methods: {
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => this.$router.replace({ name: "Login" }));
    },
    closeSnack() {
      this.$store.dispatch("app/closeSnackBar");
    }
  }
};
</script>
